import {
  Center,
  Flex,
  Pagination as PaginationMantine,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { Trans, useTranslation } from "react-i18next";
export interface IPaginationData {
  page: number;
  pageSize: number;
  totalElements: number | undefined;
  totalPages: number | undefined;
  view: number;
}
interface IProps {
  pagination: IPaginationData;
  onChange?: (page: number) => void;
  isEspecial?: boolean;
}
const Pagination = ({ pagination, onChange, isEspecial = false }: IProps) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const paginationData = {
    page: pagination.page,
    pageSize:
      !!pagination?.totalElements &&
      pagination?.totalElements <= pagination.pageSize
        ? pagination?.totalElements
        : pagination.pageSize,
    totalElements: pagination?.totalElements || 0,
    totalPages: pagination?.totalPages || 0,
    view: pagination?.view || 0,
  };

  return paginationData.totalElements && paginationData.totalElements > 0 ? (
    <Flex
      bg={theme.colors.basic[0]}
      justify={{
        base: isEspecial ? "space-between" : "center",
        780: "space-between",
      }}
      align="center"
      gap="16px"
      direction={{ base: isEspecial ? "row" : "column", 780: "row" }}
      w="100%"
    >
      <Text>
        <Trans
          i18nKey="global.pagination.text"
          components={{ bold: <Text component="b" span /> }}
          values={{
            show: paginationData.view,
            total: paginationData.totalElements.toString(),
          }}
        />
      </Text>
      <PaginationMantine
        sx={{
          gap: "16px",
          button: {
            width: "40px",
            height: "52px",
            fontSize: "14px",
            lineHeight: "32px",
            fontWeight: 500,
            border: "none",
            color: theme.colors.basic[4],
            "&[data-active]": {
              background: theme.colors.primary[1],
            },
            svg: {
              height: "30px",
              width: "30px",
            },
          },
        }}
        siblings={0}
        total={paginationData.totalPages || 0}
        onChange={onChange}
        radius="xl"
        value={pagination.page}
      />
    </Flex>
  ) : (
    <Center mt="32px" h={"100px"} w="100%">
      <Text> {t("global.pagination.no_data")}</Text>
    </Center>
  );
};

export default Pagination;
